import axios, { AxiosPromise, AxiosRequestConfig } from 'axios'
import { getAuthToken } from 'services/session'

const axiosInstance = axios.create()

axiosInstance.interceptors.request.use(async (config: AxiosRequestConfig) => {
  const token = await getAuthToken()
  config.headers.Authorization = `Bearer ${token}`
  return config
})

const makeRequestOptions = (options: AxiosRequestConfig): AxiosRequestConfig => ({
  responseType: 'arraybuffer',
  headers: { Accept: 'application/x-protobuf', ...options.headers },
  ...options,
})

export const get = (url: string, options: AxiosRequestConfig = {}) =>
  axiosInstance.get(url, makeRequestOptions(options))

export const post = (url: string, data?: any, options: AxiosRequestConfig = {}) => // tslint:disable-line:no-any
  axiosInstance.post(url, data, makeRequestOptions(options))

export const put = (url: string, data?: any, options: AxiosRequestConfig = {}) => // tslint:disable-line:no-any
  axiosInstance.put(url, data, makeRequestOptions(options))

export const del = (url: string, options: AxiosRequestConfig = {}) => // tslint:disable-line:no-any
  axiosInstance.delete(url, makeRequestOptions(options))

export const patch = (url: string, data?: any, options: AxiosRequestConfig = {}) => // tslint:disable-line:no-any
  axiosInstance.patch(url, data, makeRequestOptions(options))

export const handleRequest = async <T>(
  promise: AxiosPromise<ArrayBuffer>,
  handler: { decode(reader: Uint8Array): T }
) => {
  try {
    const response = await promise
    return handler.decode(new Uint8Array(response.data))
  } catch (err) {
    throw err
  }
}
